import { z } from 'zod'

export const leaseSchema = z.object({
  unit_id: z.number().int().positive('Unit is required'),
  customer_id: z.number().int().positive('Customer is required'),
  started_at: z.string().min(1, 'Start date is required'),
  ended_at: z.string().optional(),
  deposit: z.number().min(0, 'Deposit must be a positive number'),
  // T156-010 (EP-156 §3.3) — two optional, invoicing-independent lease
  // charges. Empty on the form means null, never 0.
  move_in_fee_amount: z.number().min(0, 'Must be a positive number').nullable().optional(),
  keycard_deposit_amount: z.number().min(0, 'Must be a positive number').nullable().optional(),
})

export type LeaseFormData = z.infer<typeof leaseSchema>
